import PropTypes from "prop-types"
import React, { useState } from "react"

import { useLocalStorageState } from "src/hooks/use_local_storage_state"

const stylesByVariant = {
  info: {
    container: "border-blue-200 bg-blue-50 text-blue-800",
    icon: "icon-info-circle text-blue-600",
  },
  warning: {
    container: "border-yellow-200 bg-yellow-50 text-yellow-800",
    icon: "icon-exclamation-circle text-yellow-600",
  },
  error: {
    container: "border-red-200 bg-red-50 text-red-800",
    icon: "icon-exclamation-circle text-red-600",
  },
}

const InlineNotice = ({
  children,
  variant = "info",
  icon = "icon-export-sheet",
  dismissible = false,
  storagePrefix,
  storageKey,
  className = "",
}) => {
  const usePersistedDismissal =
    dismissible && Boolean(storagePrefix) && Boolean(storageKey)
  const [persistedDismissed, setPersistedDismissed] = useLocalStorageState(
    storagePrefix || "inline_notice",
    storageKey || "default"
  )
  const [localDismissed, setLocalDismissed] = useState(false)
  const dismissed = usePersistedDismissal
    ? Boolean(persistedDismissed)
    : localDismissed

  if (dismissed) return null

  const variantStyles = stylesByVariant[variant]

  const handleDismiss = () => {
    if (usePersistedDismissal) {
      setPersistedDismissed(true)
      return
    }
    setLocalDismissed(true)
  }

  return (
    <div
      className={`flex items-center gap-2 rounded border px-3 py-2 text-sm ${variantStyles.container} ${className}`}
      role="status"
    >
      {icon && (
        <i
          className={`icon ${icon} text-base leading-none`}
          aria-hidden="true"
        />
      )}
      <div className="min-w-0 flex-1">{children}</div>
      {dismissible && (
        <button
          type="button"
          aria-label="Don't show again"
          onClick={handleDismiss}
          className="bg-transparent p-0 text-xs font-medium underline underline-offset-2 opacity-80 transition-opacity hover:opacity-100"
        >
          Don&apos;t show again
        </button>
      )}
    </div>
  )
}

InlineNotice.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(["info", "warning", "error"]),
  icon: PropTypes.string,
  dismissible: PropTypes.bool,
  storagePrefix: PropTypes.string,
  storageKey: PropTypes.string,
  className: PropTypes.string,
}

export default InlineNotice
